import { Injectable } from '@angular/core';
import { doc, getDoc, setDoc, Timestamp } from 'firebase/firestore';
import { FirebaseService } from './firebase.service';

export interface NextDayBiasFactor {
  label: string;
  value: string;
  direction: 'bull' | 'bear' | 'neutral';
}

export interface NextDayBiasDoc {
  ticker: string;
  signal: 'BUY' | 'SELL';
  score: number;
  rangeChar: string;
  factors: NextDayBiasFactor[];
  ivUsed: number | null;
  basedOnDate: string;
  savedAt: Timestamp;
}

@Injectable({ providedIn: 'root' })
export class NextDayBiasService {
  private db: FirebaseService['db'];

  constructor(firebase: FirebaseService) {
    this.db = firebase.db;
  }

  async save(data: Omit<NextDayBiasDoc, 'savedAt'>): Promise<void> {
    await setDoc(doc(this.db, 'nextDayBiasLatest', data.ticker), {
      ...data,
      savedAt: Timestamp.now(),
    });
  }

  async get(ticker: string): Promise<NextDayBiasDoc | null> {
    const snap = await getDoc(doc(this.db, 'nextDayBiasLatest', ticker));
    return snap.exists() ? (snap.data() as NextDayBiasDoc) : null;
  }
}
